export const baseURL = 'https://backend.soundtalksweb.com/api/v2/opu';
export const i18nBackendLoadPath = '/public/locales/{{lng}}/{{ns}}.json';
export const googleMapsKey = 'AIzaSyAnWJSarkqgNTx5ocG3PjsFUKrCNCuAnaQ';
export const externalBaseUrl = 'https://backend.soundtalksweb.com';
export const isChinaConfig = false;
export const reversedFullName = false;
export const isDemo = false;
export const enableSubscription = false;
